import { AccountClient, GET_FIELD } from '@nile/graphql';
import { ApolloClient, useQuery } from '@apollo/client';
import { useState } from 'react';

const useGetDefaultTicketType = ({
  client = AccountClient as ApolloClient<object>
}: {
  client?: ApolloClient<object>;
}) => {
  const [defaultTicketType, setDefaultTicketType] = useState('Incident');

  const { loading: defaultTicketTypeLoading } = useQuery(GET_FIELD, {
    client: client ?? AccountClient,
    variables: {
      input: {
        module: 'TICKET',
        columnName: 'ticketType'
      }
    },
    onCompleted: (res) => {
      const options =
        res?.getField?.options || res?.getField?.fieldOptions || [];
      const incidentType = options.find(
        (type) => type?.details?.property === 'INCIDENT'
      );
      setDefaultTicketType(incidentType?.value || 'Incident');
    }
  });

  return { defaultTicketType, defaultTicketTypeLoading };
};

export default useGetDefaultTicketType;
